import { ConsentWorkflow, FormDefinitionType } from '@/api/dtos';
import ConsentStandardFields from '@/components/consent/ConsentStandardFields';
import ConsentStandardForm from '@/components/consent/ConsentStandardForm';
import { useScopedField } from '@ngt/forms-core';
import { GroupedField, ToggleButtonGroup } from '@ngt/opms';
import { FC } from 'react';

const OptionalConsentQuestions: FC = () => {
    const { state: { value: workflow } } = useScopedField<ConsentWorkflow>(
        'workflow',
        { value: true },
        false,
        false
    );
    const disabled = workflow !== ConsentWorkflow.Standard;

    return (
        <>
            <GroupedField
                propertyPath="agreedToTissueSampleStorage"
                component={ToggleButtonGroup}
                disabled={disabled}
            />
            <GroupedField
                propertyPath="agreedToBloodStorage"
                component={ToggleButtonGroup}
                disabled={disabled}
            />
            <GroupedField
                propertyPath="agreedToInfoSharing"
                component={ToggleButtonGroup}
                disabled={disabled}
            />
            <GroupedField
                propertyPath="agreedToWeShareSharing"
                component={ToggleButtonGroup}
                disabled={disabled}
            />
        </>
    );
};

const OptionalConsentStandardForm: FC = () => (
    <ConsentStandardForm
        formDefinitionId={FormDefinitionType.OptionalConsentForm}
    >
        <ConsentStandardFields picfTypeName="Tissue">
            <OptionalConsentQuestions />
        </ConsentStandardFields>
    </ConsentStandardForm>
);

export default OptionalConsentStandardForm;
